import { render, staticRenderFns } from "./IncidentCreate.vue?vue&type=template&id=471753c6"
import script from "./IncidentCreate.js?vue&type=script&lang=js&external"
export * from "./IncidentCreate.js?vue&type=script&lang=js&external"
import style0 from "./IncidentCreate.vue?vue&type=style&index=0&id=471753c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports